module.exports = __webpack_public_path__ + "img/logo_prime.4dd86076.jpg";